import React from 'react'

export const ImgContext = React.createContext({
  onImgRef: null,
  onChangeScale: null,
})
